import * as types from '../../actions/actionsTypes/datiRegistroActionType';

export const InitialStateDatiRegistro = {
    resocontoMese: [],
    resocontoIndividuo: [],
    totalCount: 0,
    individuiSelezionati: [],
    error: []
};

export const datiRegistroReducer = (state = InitialStateDatiRegistro, action) => {

    switch (action.type){

        case types.INIT_RESOCONTO_MESE_REDUCER:
            return {
                error: [],
                resocontoMese: state.resocontoMese,
                resocontoIndividuo: [],
                totalCount: state.totalCount,
                individuiSelezionati: []
            };

        case types.RICERCA_TIMBRATURE_START_REGISTRO_END :
            return {
                ...state,
                resocontoMese: action.dataRegistry ?? state.resocontoMese,
                resocontoIndividuo: action.individuoRegistry ?? state.resocontoIndividuo,
                totalCount: action.totalCount ?? state.totalCount,
                error: action.errors
            }

        case types.SET_INDIVIDUI_SELEZIONATI_REGISTRO : {
            return {
                ...state,
                individuiSelezionati: action.arrayObjInd
            }
        }

        default:
            return state;
    }
};



